import React from 'react';
import css from './index.css';
import getSize from "../../utils/getSize";
import NHTable from "../common/NHTable";
import { Modal,Button } from 'antd';
import QrCode from './qrCode';

export default class DistributeClassIndex extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            initData:{},  //初始数据
        }
    }

    componentDidMount(){

    }

    handleShowBtnClick =(recode) =>{
        this.setState({
            initData: recode,
            visible: true
        })
    }

    onHandleCancel =() =>{
        this.setState({
            visible: false,
        });
    }

    render() {
        const columns = [
            {
                title: '序号',
                width: '60px',
                dataIndex: 'ROW_ID'
            },{
                title: '院系',
                width: '120px',
                dataIndex: 'BMMC',
                searchType:"select"
            },{
                title: '专业',
                width: '120px',
                dataIndex: 'ZYMC',
                searchType:"select"
            },{
                title: '年级',
                width: '80px',
                dataIndex: 'SSNJ',
                searchType:"select"
            },{
                title: '班级',
                width: '120px',
                dataIndex: 'BJMC',
                searchType:"select"
            }
        ];

        const action = [
            {title: '查看二维码', onClick: this.handleShowBtnClick,auth:'zhxg_yxgl_distributeClass_show'}
        ];
        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 123}}>
                <div className={css.table}>
                    <NHTable ref={ele => this.nhTable = ele}
                             rowKey={record =>  record.BJID}
                             sign={"zhxg_yxxt_distributeClass"}
                             columns={columns}
                             action={action}
                             checkbox={false}
                             rangeFilter={true}
                    />
                </div>
                <Modal
                    title="学生分配班级二维码"
                    visible={this.state.visible}
                    onCancel={this.onHandleCancel}
                    footer={[
                        <Button onClick={this.onHandleCancel}>
                            关闭
                        </Button>,
                    ]}>
                    <QrCode initData={this.state.initData}/>
                </Modal>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./components/distributeClass/index.js